const $ = jQuery.noConflict()

var self = module.exports = {
  init: function (target) {
    var body = $('body')
    var height = $(target).outerHeight()
    var inner = $(target).find('.header').outerHeight()
    var topbar = $(target).find('.topbar').outerHeight()
    var next = $('#wrapper').find('section').first()
    var hero = $(next).find('.hero-large')

    if ($(target).hasClass('transparent') && hero.length) {
      self.service.padding(body, topbar, 'top')
      self.service.height(hero, topbar)
    } else {
      self.service.padding(body, height, 'top')

      if (hero.length) {
        self.service.height(hero, height)
      }
    }

    self.events.scroll(target, height, topbar)
  },

  events: {
    scroll: function (target, height, topbar) {
      var lastScrollTop = 0

      $(window).on('scroll', function () {
        var st = $(this).scrollTop()
        self.service.class.toggle(target, topbar)
        self.service.padding(parent, height, 'top')

        if (st > lastScrollTop && st > 100) {
          $(target).removeClass('show').addClass('hide')
          $('.fixed-banner').removeClass('show').addClass('hide')
          $(target).css('transform', 'translateY(-' + topbar + 'px)')
        } else {
          $(target).removeClass('hide').addClass('show')
          $('.fixed-banner').removeClass('hide').addClass('show')
          $(target).css('transform', 'translateY(0)')
        }

        lastScrollTop = st
      })
    }
  },

  service: {
    padding: function (target, height, position) {
      if (position === 'top') {
        $(target).css('padding-top', height)
      } else {
        $(target).css('padding-bottom', height)
      }
    },

    height: function (target, height) {
      var minHeight = 'calc(100vh - ' + height + 'px)'
      $(target).css('height', minHeight)
    },

    position: function () {
      var top = $(window).scrollTop()
      return top
    },

    class: {
      toggle: function (target) {
        if (self.service.position() > 100) {
          self.service.class.add(target)
        } else {
          self.service.class.remove(target)
        }
      },

      add: function (target) {
        $(target).addClass('scrolled')
      },

      remove: function (target) {
        $(target).removeClass('scrolled')
      }
    }
  }
}

// show branch nav on header

$(".branch-dropdown").on( "click", function(event) {
  event.preventDefault()
  $('#branch-nav').addClass('show');
});

$(".header__close").on( "click", function() {
  $('#branch-nav').removeClass('show');
});
